export const JOBS_RETRIED_EVENT = "RealQueue/JobsRetried";
